import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

export interface AiSuggestionRowProps {
  label: string;
  description?: string;
  onAccept: () => void;
  onEdit?: () => void;
  onDismiss: () => void;
  loading?: boolean;
}

/**
 * Wave 2 suggest-only pattern: user must Accept, Edit, or Dismiss structural AI output.
 */
export function AiSuggestionRow({
  label,
  description,
  onAccept,
  onEdit,
  onDismiss,
  loading,
}: AiSuggestionRowProps) {
  const { t } = useTranslation('common');

  return (
    <div className="rounded-xl border border-primary/25 bg-primary/5 p-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-primary">{t('aiSuggestion.suggested')}</p>
      <p className="mt-1 text-sm font-semibold text-foreground">{label}</p>
      {description ? <p className="mt-1 text-xs text-muted-foreground">{description}</p> : null}
      <div className="mt-3 flex flex-wrap gap-2">
        <Button type="button" size="sm" disabled={loading} onClick={onAccept}>
          {t('aiSuggestion.accept')}
        </Button>
        {onEdit ? (
          <Button type="button" size="sm" variant="outline" disabled={loading} onClick={onEdit}>
            {t('aiSuggestion.edit')}
          </Button>
        ) : null}
        <Button type="button" size="sm" variant="ghost" disabled={loading} onClick={onDismiss}>
          {t('aiSuggestion.dismiss')}
        </Button>
      </div>
    </div>
  );
}
